<template>
    <el-dialog title="选择档位" :visible.sync="innerVisible" class="dialog-table" width="800px" :before-close="closeDialogTable">
        <!-- <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
            <el-form-item label="短剧名" prop="svName">
                <el-input v-model="formInline.svName" placeholder="请输入短剧名" clearable @keyup.enter.native="search" @clear="search" style="width: 220px;"></el-input>
            </el-form-item>
            <el-form-item label="短剧ID" prop="svId">
                <el-input type="number" v-model="formInline.svId" placeholder="请输入短剧ID" clearable @keyup.enter.native="search" @clear="search" style="width: 220px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form> -->
        <div class="tableTh">
            <el-table :data="tableData.result" border ref="multipleTable" @selection-change="handleSelectionChange" @row-click="handleRowClick" max-height="345" row-key="id" style="width: 100%" class="tableStyle">
                <el-table-column type="selection" width="60" align="center">
                </el-table-column>
                <el-table-column label="充值类型" width="100">
                    <template slot-scope="scope">
                        <!-- <span v-if="scope.row.durationType==0">充值金币</span>
                        <span v-if="scope.row.durationType==1">月度会员</span>
                        <span v-if="scope.row.durationType==2">年度会员</span>
                        <span v-if="scope.row.durationType==3">普通会员</span>
                        <span v-if="scope.row.durationType==4">季度会员</span> -->
                        <span v-if="scope.row.rechargeType == 0">充值金币</span>
                        <span v-if="scope.row.rechargeType == 1">
                            {{scope.row.durationType == 1 ? '月度会员' : scope.row.durationType == 4 ? '季度会员' : scope.row.durationType == 2 ? '年度会员' : scope.row.durationType == 3 ? scope.row.days + '天会员' : ''}}
                        </span>
                        <span v-if="scope.row.rechargeType == 3">单剧购买</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值金额" width="120">
                    <template slot-scope="scope">
                        <p>实付金额：{{ scope.row.money }}</p>
                        <p>划线价：{{ scope.row.originalPrice }}</p>
                        <p v-if="scope.row.rechargeType == 3">剧名：{{scope.row.videoName}}；</p>
                    </template>
                </el-table-column>
                <el-table-column label="金币数量">
                    <template slot-scope="scope">
                       <span>{{ scope.row.rechargeType==0?scope.row.money * 100 + scope.row.present:0 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值说明" width="180">
                    <template slot-scope="scope">
                        <span>{{ scope.row.rechargeInfo }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="档位描述" width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.templateInfo}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="展示角标" width="80">
                    <template slot-scope="scope">
                        <div>	
                            <span class="succes-text" v-if="scope.row.isShowSubscript == 1">已展示</span>
                            <span class="danger-text"  v-if="scope.row.isShowSubscript == 0">未展示</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="展示文案" width="100">
                    <template slot-scope="scope">
                      <span>{{ scope.row.subscript }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="foot-table" style="text-align:center;">
                <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :page-sizes="[5, 20, 50, 100, 200, 500]"
                    :page-size="pageSize"
                    background
                    :current-page="currentPage"
                    layout="sizes, prev, pager, next, jumper, ->, total"
                    :total="tableData.totalNum">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
// import { listVideoMedia } from "@/api/dysvzk/dymedia/add";
import { list } from "@/api/dysvzk/app/recharge";
// import { listVideoMore } from "@/api/dysvzk/app/group";
var videoList = []
var videoListStr = ''
export default {
    name: 'RechargeTableMore',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        // selectVideo: {
        //     type: Object,
        //     required: true
        // },
        videoListType: String,
        appId: String,
        selectList:{
            type: Array,
            required: true
        },
    },
    data() {
        return {
            innerVisible: this.visible,
            selected: [],
            formInline: {
                svId: '',
                svName: ''
            },
            tableData: {
                pageSize: 20,
                pageNo: 1,
                totalPage: 1,
                totalNum: 0,
                result: []
            },
            currentPage: 1,
            pageSize: 5,
            currentRow: ''
        }
    },
    watch: {
        visible(newValue) {
            this.innerVisible = newValue;
            // 弹框显示赋值默认值
            this.$nextTick(()=>{
                this.$refs.multipleTable.clearSelection();
                console.log("this.selectList",this.selectList)
                // if (this.selectList.length > 0) {
                //     this.$refs.multipleTable.toggleRowSelection(this.selectList[0],true);
                //     this.selectList.forEach(row => {
                //         this.$refs.multipleTable.toggleRowSelection(row,true);
                //         videoList.push(row.id)
                //         console.log('设置',row)
                //     });
                // }
            })
        },
        appId(newValue) {
            this.appId = newValue
            this.getTableVideoMore()
        },
        innerVisible(newValue) {
            this.$emit('update:visible', newValue);
        },
        // selectList(newValue){
        //     console.log("selectList",newValue)
        // }
    },
    mounted() {
        this.getTableVideoMore()
    },
    methods: {
        search () {
            this.currentPage = 1
            this.getTableVideoMore()
        },
        resetQuery() {
            this.$refs['formInline'].resetFields()
            this.getTableVideoMore()
        },
        handleRowClick(row) {
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        // 多选
        handleSelectionChange(val) {
            console.log(val)
            videoList = []
            val.forEach((item) => {
                videoList.push(item.id)
            })
            videoListStr = videoList.toString()
            this.currentRow = val
        },
        // 分页
        handleCurrentChange (value) {
            this.currentPage = value
            this.getTableVideoMore()
        },
        // pageSize切换
        handleSizeChange (val) {
            this.pageSize = val
            this.currentPage = 1
            this.getTableVideoMore()
        },
        // 确定按钮
        tableSureBtn() {
            if(videoListStr){
                this.$emit('gearSure', {
                    currentRow: this.currentRow,
                    videoListStr: videoListStr,
                });
                this.$emit('cancelDialogVideo', false);
            } else {
                this.$message.error('请选择档位')
            }
            
            // this.$emit('videoSure', this.currentRow);
            // this.$emit('cancelDialogVideo', false);
            // this.$refs.singleTable.setCurrentRow();
        },
        // 关闭弹框
        closeDialogTable () {
            console.log(22)
            this.$emit('cancelDialogVideo', false);
        },
        getTableVideoMore() {
            let json2 = {
                appId: this.appId,
                pageNo: this.currentPage,
                pageSize: this.pageSize
            };
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 };
            list(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
    }
}
</script>
